"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheStore = _interopRequireDefault(require("../CacheStore"));

var _UnsupportedException = _interopRequireDefault(require("../exception/UnsupportedException"));

var _AbstractMethodException = _interopRequireDefault(require("../exception/AbstractMethodException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Settings manager.
 */
var AbstractSettingsManager = /*#__PURE__*/function () {
  function AbstractSettingsManager() {
    _classCallCheck(this, AbstractSettingsManager);
  }

  _createClass(AbstractSettingsManager, null, [{
    key: "applySettings",

    /**
     * Applies multiple service settings.
     *
     * @param {object} settings Settings object.
     */
    value: function applySettings(settings) {
      var defaultSettings = this.getDefaultSettings();

      for (var _i = 0, _Object$keys = Object.keys(settings); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (defaultSettings[key] !== undefined) {
          if (settings[key] !== undefined) {
            this[key] = settings[key];
          }
        } else {
          throw new _UnsupportedException.default('The setting with key "' + key + '" is not supported in "' + this.name + '".');
        }
      }
    }
    /**
     * Returns all settings as an object.
     *
     * @returns {object} All settings.
     */

  }, {
    key: "getAllSettings",
    value: function getAllSettings() {
      var settings = {};

      var _iterator = _createForOfIteratorHelper(this.settings.store),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          settings[key] = value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return settings;
    }
    /**
     * Returns the default settings.
     *
     * @abstract
     * @returns {object} Default settings as an object.
     */

  }, {
    key: "getDefaultSettings",
    value: function getDefaultSettings() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Applies properties for the settings.
     */

  }, {
    key: "setupProperties",
    value: function setupProperties() {
      var _this = this;

      var defaultSettings = this.getDefaultSettings();

      var _loop = function _loop() {
        var key = _Object$keys2[_i2];

        if (_this[key] === undefined) {
          Object.defineProperty(_this, key, {
            set: function set(value) {
              _this.settings.set(key, value);
            },
            get: function get() {
              return _this.settings.get(key);
            }
          });
        }
      };

      for (var _i2 = 0, _Object$keys2 = Object.keys(defaultSettings); _i2 < _Object$keys2.length; _i2++) {
        _loop();
      }
    }
    /**
     * Returns the settings manager name.
     *
     * @abstract
     * @returns {string} Settings manager name.
     */

  }, {
    key: "settingsName",
    get: function get() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Returns the settings.
     *
     * @returns {CacheStore} Settings cache store.
     */

  }, {
    key: "settings",
    get: function get() {
      if (!this._cacheStore) {
        this._cacheStore = new _CacheStore.default(this.settingsName);

        if (this._cacheStore.size === 0) {
          var defaultSettings = this.getDefaultSettings();

          for (var _i3 = 0, _Object$keys3 = Object.keys(defaultSettings); _i3 < _Object$keys3.length; _i3++) {
            var key = _Object$keys3[_i3];

            this._cacheStore.set(key, defaultSettings[key]);
          }
        }
      }

      return this._cacheStore;
    }
  }]);

  return AbstractSettingsManager;
}();

exports.default = AbstractSettingsManager;